import { Spinner } from "../../../../atoms";

const GroupingTemplateApiLoading = () => {
  return (
    <Spinner></Spinner>
  );
};

export default GroupingTemplateApiLoading;
